import { useLocation } from "react-router-dom";
import Seo from "./Seo";

const PRIVATE_DESCRIPTION =
    "Private JnS Creation account, checkout, order, or support page.";

export default function NoIndexRoute({ title = "Private page", description = PRIVATE_DESCRIPTION, children }) {
    const { pathname } = useLocation();

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={pathname}
                noindex
            />
            {children}
        </>
    );
}
